import React from "react";
import {Notification} from "../modules/Notification/page/Notification";

export function DashboardPage() {
  return <Notification/>;
}
